import { TableColumn } from '@shared/interfaces';

/**
 * The columns data for the licenses table.
 */
export const LICENSE_COLUMNS: TableColumn[] = [
    // { field: 'screenshot', header: 'Screenshot', width: '120px', type: 'image' },
    {
        field: 'licenseKey',
        header: 'License Key',
        width: '250px',
        type: 'status-copy',
        hasRedirect: true,
        truncateLimit: 0,
    },
    { field: 'dealer', header: 'Dealer', width: '200px' },
    // { field: 'host', header: 'Host', width: '200px' },
    { field: 'anydesk', header: 'Anydesk', width: '200px' },
    { field: 'alias', header: 'Alias', width: '150px' },
    { field: 'createdDate', header: 'Created Date', width: '150px' },
    // {
    //     field: 'actions',
    //     header: 'Actions',
    //     width: '150px',
    //     type: 'actions',
    //     actions: [
    //          { icon: 'screenshot', name: 'screenshot' },
    //         { icon: 'delete', name: 'delete', color: 'red' },
    //     ],
    // },
];

/**
 * Valid fields for license search.
 */
export const LICENSE_SEARCH_FIELDS: string[] = [
    'licenseId', // UUID partial search - confirmed working per backend team
    'licenseKey', // TODO: Pending backend support for partial search on UUID binary column
    'alias',
    'hostLocation.city',
    'hostLocation.zip',
    'hostLocation.region',
    'hostLocation.hostLocationName',
    'owner.firstName',
    'owner.lastName',
];
